import { useNavigate, useSearchParams } from "react-router-dom";

import Modal from "shared/components/feedback/modals/MasterModal";
import PageWrapper from "app/components/PageWrapper";
import RegionsForm from "features/admin/regions/RegionsForm";
import RegionsTable from "features/admin/regions/RegionsTable";

const FormPresenter = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const action = searchParams.get("action");
    const id = searchParams.get("id");

    const onClose = () => {
        navigate(".", { replace: true });
    };

    if (action === "add") {
        return (
            <Modal title="Add Region" onRequestClose={onClose}>
                <RegionsForm key="new" onClose={onClose} />
            </Modal>
        );
    }

    const parsedId = Number.parseInt(id);

    if (action === "edit" && !Number.isNaN(parsedId)) {
        return (
            <Modal title="Edit Region" onRequestClose={onClose}>
                <RegionsForm
                    regionIdToEdit={parsedId}
                    key={parsedId}
                    onClose={onClose}
                />
            </Modal>
        );
    }

    return <></>;
};

const Regions = () => {
    return (
        <PageWrapper
            title="Regions"
            menuOptions={[{ children: "Admin", to: "/admin" }]}
        >
            <FormPresenter />
            <RegionsTable />
        </PageWrapper>
    );
};

export default Regions;
